import { schema } from 'normalizr'

export const rate = new schema.Entity('rates', {}, { idAttribute: 'ourId' })
export const arrayOfRates = new schema.Array(rate)



// WEBPACK FOOTER //
// ./src/adapters/hwRateSchema.js